import React, { useEffect, useState, FC } from "react"
import { observer } from "mobx-react-lite"
import { ViewStyle, FlatList, Appearance, Alert } from "react-native"
import { Screen, NotificationItem, JalaLoading } from "../../components"
import { color } from "../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { useStores } from "../../models"
import { FlyingButton, EmptyNotif } from "./FarmingNotification-screen"
import moment from "moment"
import { navigate } from "../../navigators"
import { Modal, View } from "native-base"
import { delay } from "../../utils/delay"
import JalaAnalytic from "../../utils/jala-analytic"
import { SafeAreaView } from "react-native-safe-area-context"
import { translate } from "../../i18n"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  flex: 1,
}

const CONTENT_LIST_CONTAINER: ViewStyle = {
  // flexGrow: 1,
  backgroundColor: color.palette.white,
  paddingBottom: 68
}

const notificationTypes = [
  'App\\Notifications\\NewShrimpPriceInfo'
]

export const InfoNotificationScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function InfoNotificationScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const {
    tokenStore: { token },
    notificationsStore, notificationsStore: { InfoNotifications, loading, error },
    shrimpPriceStore,
    shrimpPriceStore: { shrimpPrice }
  } = useStores()

  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [allRead, setAllRead] = useState<boolean>(false);

  useEffect(() => {
    if (shrimpPriceStore.shrimpPrices.length === 0) shrimpPriceStore.init()
  }, [notificationsStore, shrimpPriceStore])

  useEffect(() => {
    if (token) notificationsStore.init(notificationTypes)
  }, [notificationsStore, token])

  // useEffect(() => {
  //   if (token) {
  //     notificationsStore.fetchNotifications(1, notificationTypes, true)
  //   }
  // },[notificationsStore, route.name, token])

  useEffect(() => {
    JalaAnalytic.log('Mobile app: home - notifications - media');
  }, [])

  const onRefresh = () => {
    setRefreshing(true)
    notificationsStore.fetchNotifications(1, notificationTypes, true)
      .finally(() => setRefreshing(false))
  }

  const markAsRead = (item: { id: any }) => {
    const index = InfoNotifications.findIndex((notification) => notification.id === item.id);
    const ns = [...InfoNotifications];
    ns[index].read_at = moment.utc().format('YYYY-MM-DD HH:mm:ss');
    ns[index].unread = false;
    notificationsStore.set('notifications', [...ns])
    notificationsStore.fetchNotification(item.id).catch();
  }

  const onPress = (item) => async () => {
    JalaAnalytic.log('Mobile: Notification - Post clicked', { props: item })
    const id = item.data.id || null;
    if (notificationTypes.includes(item.type) && id) {
      markAsRead(item);
      shrimpPriceStore.set('shrimpPriceId', id);
      await delay(1);
      shrimpPriceStore.getShrimpPriceById().then((resp) => {
        navigate('Home.Stack', "Home.ShrimpPrice.Detail", {shrimpPrice: resp});
      }).catch(() => Alert.alert('Error', translate('monitoring.empty'), [{ text: 'OK' }], { cancelable: false }))
    }
  }

  const markAllAsRead = () => {
    setAllRead(true)
    notificationsStore.set('notifPage', 1)
    notificationsStore.markNotificationsRead(notificationTypes)
      .then(() => notificationsStore.fetchNotifications(1, notificationTypes, true))
      .finally(() => setAllRead(false));
  }

  const renderitemNotification = (item) => (
    <NotificationItem notification={item.item} onPressItem={onPress(item.item)} />
  )

  const renderListNotification = () => (
    <FlatList
      keyExtractor={(item) => (item.id)}
      data={InfoNotifications}
      renderItem={renderitemNotification}
      onRefresh={onRefresh}
      refreshing={refreshing}
      // onEndReached={() => {
      //   if (meta.current_page && meta.current_page < meta.last_page) {
      //     notificationsStore.fetchNotifications(page + 1, notificationTypes, true)
      //     notificationsStore.set('page', page + 1)
      //   }
      // }}
      // onEndReached={() => notificationsStore.getNotificationsNext(notificationTypes)}
      onEndReachedThreshold={0.1}
      // ListFooterComponent={(
      //   (meta.current_page && meta.current_page < meta.last_page) && (
      //   <View style={FOOTER_LIST}>
      //     <ActivityIndicator size={28} />
      //   </View>
      //   )
      // )}
      ListFooterComponent={<SafeAreaView edges={['bottom']} />}
      contentContainerStyle={CONTENT_LIST_CONTAINER}
    />
  )

  const unreadNotifications = InfoNotifications.filter((notification) => notification.unread);
  return (
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.background : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      {!!InfoNotifications.length && !loading && !error
        ? renderListNotification()
        : <EmptyNotif isError={error} loading={loading} onRefresh={onRefresh} />
      }
      {!!InfoNotifications.length && !!unreadNotifications.length && (
        <FlyingButton
          onPress={markAllAsRead}
          state={allRead}
        />
      )}
      <Modal isOpen={loading}>
        <View
          width="72px" height="72px"
          alignItems="center"
          justifyContent="center"
          rounded="48px"
          backgroundColor="rgba(255, 255, 255, 0.75)"
        >
          <JalaLoading />
        </View>
      </Modal>
    </Screen>
  )
})
